/**
 * REST API Gateway (Placeholder Implementation)
 *
 * This is a placeholder implementation for the REST API gateway.
 * To be properly implemented in future stories when API integration is needed.
 *
 * For now, it provides stub methods to satisfy the store dependency injection.
 */

import type { IRestApiGateway, ApiResponse } from '@/domain/ports/IRestApiGateway';

export class RestApiGateway implements IRestApiGateway {
  // @ts-expect-error - Reserved for future auth token implementation
  private _authToken: string | null = null;

  async get<T>(path: string, _params?: Record<string, unknown>): Promise<ApiResponse<T>> {
    console.warn(`RestApiGateway.get() called with ${path} - Not implemented yet`);
    return { data: {} as T, status: 200 };
  }

  async post<T>(path: string, _body?: unknown): Promise<ApiResponse<T>> {
    console.warn(`RestApiGateway.post() called with ${path} - Not implemented yet`);
    return { data: {} as T, status: 201 };
  }

  async put<T>(path: string, _body?: unknown): Promise<ApiResponse<T>> {
    console.warn(`RestApiGateway.put() called with ${path} - Not implemented yet`);
    return { data: {} as T, status: 200 };
  }

  async delete<T>(path: string): Promise<ApiResponse<T>> {
    console.warn(`RestApiGateway.delete() called with ${path} - Not implemented yet`);
    return { data: {} as T, status: 204 };
  }

  setAuthToken(token: string): void {
    this._authToken = token;
  }

  clearAuthToken(): void {
    this._authToken = null;
  }
}
